var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',_vm._g(_vm._b({},'router-view',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }